ModelCache = require 'db/model-cache'
ModelCacheListener = require 'views/internal/model-cache-listener'
ModelLoader = require 'db/model-loader'
Notification = require 'models/notification'
NotificationList = require 'views/notification/notification-list'
React = require 'react'
t = require('views/internal/recup-with-helpers')('member_notifications')
_ = require 'underscore'

getExperiment = require 'lib/experiments/simple-test'

class MemberNotificationsComponent extends React.Component
  displayName: 'MemberNotifications'

  constructor: (props) ->
    super
    @loadMore = @loadMore.bind(@)
    @updateNotifications = @updateNotifications.bind(@)
    @state =
      nextPage: 1
      isMore: false
      notifications: []

  componentDidMount: ->
    @props.listenTo 'add:Notification remove:Notification change:Notification', @updateNotifications
    @updateNotifications()

  updateNotifications: ->
    notifications = Notification.sortedByDateDescending(ModelCache)
    @setState
      notifications: notifications
      isMore: true
      nextPage: Math.floor(notifications.length / Notification.PAGE_SIZE)

  loadMore: ->
    ModelLoader.loadMoreNotificationData @props.member.get('username'), @state.nextPage
    .then (notifications) =>
      @setState
        isMore: notifications.length > Notification.PAGE_SIZE - 1
    .done()

  render: t.renderable ->
    t.div =>
      t.div '.window-module-title', ->
        t.span '.window-module-title-icon.icon-lg.icon-notification'
        t.h3 ->
          t.format 'notifications'

      if @state.notifications.length == 0
        t.div '.empty-list', ->
          t.format 'no-notifications'
      else if getExperiment('manualNotifications').get('markRead')
        t.a '.js-mark-all-read.mark-all-read.quiet', {
          href: '',
          onClick: @props.member.clearAllNotifications,
          style: {
            display: 'block',
            textAlign: 'right',
            width: '100%',
            marginLeft: '-25px'
          }
        }, ->
          t.format 'mark-all-read'

      t.div '.js-list-notifications', =>
        t.createElement NotificationList, { notifications: @state.notifications, context: 'notifications-page' }

      t.a '.show-more.js-more-notifications', { onClick: @loadMore, class: t.classify({ "hide": !@state.isMore }) }, ->
        t.format 'load-more-notifications'

module.exports = ModelCacheListener(MemberNotificationsComponent)



// WEBPACK FOOTER //
// ./app/scripts/views/member/member-notifications-component.coffee